export default __webpack_public_path__ + "img/98d9b9a736c38584a851380fd3c7ff11.svg";